import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AppDispatch, RootState } from '../../redux/store';
import { clearUser } from '../../redux/authSlice';
import NavItem from './NavItem';
import { useTranslation } from 'react-i18next';
import LogoutModal from '../modal/LogoutModal';
import { useCustomer } from '../../hooks/useCustomer';

const AuthenticatedHeader: React.FC = () => {
  const { t, i18n } = useTranslation('header');
  const dispatch: AppDispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);
  const { customerData } = useCustomer();


  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleConfirmLogout = () => {
    dispatch(clearUser());
    sessionStorage.setItem('isAuthenticated', 'false');
    window.location.href = '/login';
  };

  return (
    <header className="bg-custom-dark text-white pt-[30px] min-h-[70px] border-b-[3px] border-custom-orange">
      <div className="container">
        <div className="w-full h-12">
          <div className="float-right mt-[10px] text-white text-right">
            <span className="inline-block mr-[10px]">{customerData?.companyName || ''}</span>
            <span className="inline-block mr-[10px]">
              {i18n.language === 'jp' ? auth.username : auth.username_en}
            </span>
            <span className="text-sm underline cursor-pointer" onClick={handleOpenModal}>{t('logout')}</span>
          </div>
          <div className="float-left">
            <h1 className="m-0 text-[32px] leading-[51px] font-bold">Verification Management Tool <span className="text-xl leading-6">for TRUSTDOCK</span></h1>
          </div>
        </div>
        <div className="mt-3 float-right !text-white">
          <ul className="my-4">
            <NavItem to="/dashboard" label={t('dashboard')} />
            <NavItem to="/personal-inbound-list" label={t('personal verification')} />
            {/* <NavItem to="/corporate-inbound-list" label={t('legal person verification')} /> */}
            {/* <NavItem to="/corporate-reference" label={t('legal person reference')} /> */}
            {auth.role === 'admin' && <NavItem to="/users" label={t('users')} />}
            {auth.role === 'admin' && <NavItem to="/customer" label={t('customer management')} />}
          </ul>
        </div>
      </div>
      <LogoutModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmLogout}
      />
    </header>
  );
};

export default AuthenticatedHeader;
